package com.esoris.kmpmoout.domaindata.product

import kotlinx.serialization.Serializable

@Serializable
data class Product(
    val id: String,
    val name: String,
)